<style>
.countdown-container {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 0 0 5px 0;
    width: fit-content;
    max-width: 70%;
    height: fit-content;

    @media (max-width: 230px) {
        font-size: 0.7em;
    }

    @media (max-width: 185px) {
        font-size: 0.5em;
    }
}

.coursecard-shorten-text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

    @media (max-width: 300px) {
        font-size: 0.8em;
    }
    @media (max-width: 240px) {
        font-size: 0.6em;
    }
}
</style>

<template>
    <v-card elevation="4" class="ma-2 zoezi-list-card course align-stretch overflow-hidden"
        :class="{ 'full-width': titleRight }" @click="$emit('click')">
        <template v-if="!titleRight">
            <v-auto-img :src="image" :ar="3 / 2">
                <booking-status :space="course.space" :space-left="course.spaceLeft" class="float-right ma-2" />

                <div v-if="opensIn" class="primarytext--text" style="width: 100%; display: block;">
                    <div class="pa-2 countdown-container" :style="background" v-html="opensInHtml">
                    </div>
                </div>

                <v-chip class="float-left ma-1" v-text="weekDayTimeString" v-if="weekDayTimeString" />

                <div class="primary card-title" :style="background">
                    <div class="primarytext--text coursecard-shorten-text">{{ course.name }}</div>
                </div>
            </v-auto-img>

            <div class="pa-2 d-flex justify-space-between zoezi-card-details flex-wrap">
                <div v-if="course.occasions">
                    <v-icon color="primary" class="mr-2">mdi-account-details-outline</v-icon>{{ occasionsString }}
                </div>
                <div>
                    <v-icon color="primary" class="mr-2">mdi-calendar-month-outline</v-icon>{{ startDateString }}
                </div>
                <div v-if="showPrice">
                    <v-icon color="primary" class="mr-2">mdi-tag-multiple-outline</v-icon>{{ course.price | price }}
                </div>
            </div>

        </template>
        <div v-else class="d-flex align-stretch">
            <v-auto-img :src="image" class="z-half inherit-border-left" :ar="3 / 2">
                <v-chip class="float-left ma-2" v-text="weekDayTimeString" v-if="weekDayTimeString" />
                <booking-status :space="course.space" :space-left="course.spaceLeft" class="float-right ma-2" />
            </v-auto-img>
            <v-auto-img :src="image" class="card-image-blur" :ar="3 / 2" />

            <div class="z-half px-4 pt-4 d-flex flex-column align-self-stretch">
                <div class="card-title">
                    <div class="primary--text">{{ course.name }}</div>

                    <div v-if="opensIn" class="description py-1">{{ $translate('You can book in {0}').format(opensIn) }}</div>

                    <div v-html="stripHtml(course.description)" class="description" />
                </div>
                <div class="spacer fill-height"></div>
                <div class="d-flex zoezi-card-details justify-space-between py-4">
                    <div v-if="course.occasions">
                        <v-icon color="primary" class="mr-2">mdi-account-details-outline</v-icon>{{ occasionsString }}
                    </div>
                    <div>
                        <v-icon color="primary" class="mr-2">mdi-calendar-month-outline</v-icon>{{ startDateString }}
                    </div>
                    <div v-if="showPrice">
                        <v-icon color="primary" class="mr-2">mdi-tag-multiple-outline</v-icon>{{ course.price | price }}
                    </div>
                </div>
            </div>
        </div>
    </v-card>
</template>

<script>
import { stripHtml } from '../util.js'
import BookingStatus from '../components/BookingStatus.vue'
export default {
    name: 'zoezi-course-card',

    props: {
        course: {
            type: Object
        },
        singleRow: {
            type: Boolean
        },
        titleRight: {
            type: Boolean
        },
        showPrice: {
            type: Boolean
        }
    },
    components: {
        BookingStatus
    },
    methods: {
        stripHtml,
    },
    computed: {
        opensInHtml() {
            return this.$translate('You can book in {0}').format('<span style="white-space: nowrap;">' + this.opensIn + '</span>')
        },
        opensIn() {
            const diff = Math.max(Date.parse(this.course.firstBookingTime) - this.timeCounter, 0);
            if (diff <= 0) return false;

            const seconds = Math.floor(diff / 1000);
            const minutes = Math.floor(seconds / 60);
            const hours = Math.floor(minutes / 60);
            const days = Math.floor(hours / 24);
            const months = Math.floor(days / 30.44);
            const years = Math.floor(days / 365.25); // considering leap years
            const t = this.$translate;

            if (years > 0) { return `${years} ${t('years')}` }
            if (months == 1) { return `${months} ${t('month')}` }
            if (months > 0) { return `${months} ${t('months')}` }
            if (days == 1) { return `${days} ${t('day')}` }
            if (days > 0) { return `${days} ${t('days')}` }
            if (hours == 1) { return `${hours} ${t('hour')}` }
            if (hours > 0) { return `${hours} ${t('hours')}` }
            if (minutes == 1) { return `${minutes} ${t('minute')}` }
            if (minutes > 0) { return `${minutes} ${t('minutes')}` }
            if (seconds == 1) { return `${seconds} ${t('second')}` }
            if (seconds > 0) { return `${seconds} ${t('seconds')}` }
            else return '';
        },
        image() {
            if (this.course.imagekey) {
                return this.course.imagekey;
            }

            return this.$store.state.settings?.coursecategories?.find(c => c.id == this.course.category_id)?.imagekey;
        },
        startDateString() {
            if (!this.course) {
                return null;
            }

            return Date.formatFullShort(this.course.startTime).capitalize();
        },
        background() {
            return { 'background-color': this.$root.colorToHex('primary') + 'b4 !important' };
        },
        weekDayTimeString() {
            if (!this.course || !this.course.weekDayTime) {
                return null;
            }

            let t = this.course.weekDayTime;
            let startTime = t[1];
            let endTime = t[2];

            return `${this.$translate(['Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays', 'Sundays'][t[0]])}, ${startTime}-${endTime}`;
        },
        occasionsString() {
            if (this.course.occasions == 1) {
                return this.$translate('1 occasion');
            }
            return this.$translate('{0} occasions').format(this.course.occasions);
        },
        timeCounter() {
            return this.$store.state.now30s
        }
    }
}
</script>
